import styled, { css } from 'styled-components';

export const StyledContainer = styled.div(
  ({ theme, backgroundColor }) => css`
    height: 60px;
    padding: 0 ${theme.spacing.m};
    background-color: ${backgroundColor === 'hotel'
      ? theme.colors.mintGreen
      : theme.colors.lavender};
    width: ${theme.width.full};
    border-radius: ${theme.radius.s};
    display: flex;
    flex: ${theme.flex.full};
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    margin-bottom: ${theme.spacing.m};
    box-shadow: 0 3px 2px 0 rgba(0, 0, 0, 0.1);
  `
);

export const StyleCardTitleLine = styled.div`
  font: ${({ theme }) => theme.font.default};
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  color: ${({ theme }) => theme.colors.oxfordBlue};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TitleContent = styled.div`
  width: 50%;
`;

export const StyleCardSubTitleLine = styled.div`
  font: ${({ theme }) => theme.font.default};
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.fontWeight.oxfordBlue};
  color: ${({ theme }) => theme.colors.oxfordBlue};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyleCardSubDescription = styled.div`
  width: 65%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.s};
  color: ${({ theme }) => theme.colors.oxfordBlue};
  letter-spacing: 0;
  line-height: ${({ theme }) => theme.lineHeight.lh5};
  height: 18px;
`;

export const StyleCardSubDepartment = styled.div`
  width: 35%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.s};
  color: ${({ theme }) => theme.colors.oxfordBlue};
  letter-spacing: 0;
  line-height: ${({ theme }) => theme.lineHeight.lh5};
`;
